<template>
  <div class="dish_washer">
    <div class="content c895">
      <h2>Dodajte pomivalni stroj</h2>
    </div>
    <div class="content c590">
      <div class="popup popDev6" :style="{display: !err ? 'none' : 'block'}">
        <div class="inner">
          <h3></h3>
          <div class="msg">
            <h3>Izpolniti je potrebno vsaj eno polje za pogostost uporabe naprave!</h3>
          </div>

          <div class="btns">
            <a href="javascript:void(0)" class="btn" title="OK" @click="err = false">V REDU</a>
          </div>
        </div>
      </div>
      <div class="form">
        <h3>VPIŠITE PODATKE O POMIVALNEM STROJU</h3>
        <div class="f-item select">
          <label>
            Energijski razred:
            <span id style="color:Red;float:none;font-size:1em;">*</span>
            <span>(oz. leto izdelave naprave)</span>
          </label>
          <select v-model="kategorija">
            <option value="0">Izberite</option>
            <option value="1">A+++</option>
            <option value="2">A++</option>
            <option value="3">A+</option>
            <option value="4">A (po 2007)</option>
            <option value="5">B (2001-2007)</option>
            <option value="6">C (1999-2001)</option>
            <option value="7">D (1992-1999)</option>
            <option value="8">E (pred 1992)</option>
            <option value="9">F (pred 1992)</option>
            <option value="10">G (pred 1992)</option>
          </select>
        </div>
      </div>
      <div class="question">
        <p>
          Kolikokrat
          <b>na teden</b> uporabljate pomivalni stroj in kdaj?
        </p>
        <div class="help">
          <a href="#" class="help" title="Help">Help</a>
        </div>
      </div>
      <div class="answer-list">
        <ul>
          <li class="first">
            <div>PON-TOR, 6:00-22:00</div>
            <div>PON-TOR, 22:00-6:00 IN SOB-NED</div>
          </li>
          <li class="answer odd">
            <span class="small">št. pomivanj</span>
            <div>
              <input v-model="teden" type="text" id />
              <span>x</span>
            </div>
            <div class="last">
              <input v-model="vikend" type="text" id />
              <span>x</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="add">
        <input type="submit" name value="Dodaj" @click="addedApplianceNum()" />
      </div>
    </div>
    <div class="content r-c">
      <div class="c282 info">
        <h3>INFO O POMIVALNEM STROJU</h3>
        <p>Kar velja za učinkovito rabo električne energije pralnih strojev, velja tudi za pomivalne stroje. Pri tem se letna poraba električne energije pri pomivalnih strojih izredno spreminja od gospodinjstva do gospodinjstva, saj ni odvisna le od števila gospodinjskih članov, temveč tudi od prehranjevalnih navad.</p>

        <div class="average">
          <h4>Povprečna poraba pomivalnega stroja za 4 člansko družino na leto</h4>
          <span>410 kWh/leto</span>
          <p>
            <strong>49,81 € / leto</strong> (enotarifno)
            <br />
            <strong>35,62 € / leto</strong> (dvotarifno)
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PomivalniStrojObj from '../classes/pomivalni_stroj';

export default {
  data: function () {
    return {
      kategorija: '',
      teden: 0,
      vikend: 0,
      err: false,
      err2: false,
    };
  },
  methods: {
    addedApplianceNum() {
      const PX = new PomivalniStrojObj(
        this.kategorija,
        this.teden,
        this.vikend
      );
      this.$emit('applianceFormClicked', PX);
    },
  },
};
</script>

<style>
</style>